"use client";

import { cn } from "@repo/ui/lib/utils";
import { useState, useEffect } from "react";
import Icon from "@repo/ui/components/ui/icon/icon";
import Link from "next/link";
import { useCustomer } from "@/data/consumer";
import { useTranslations } from "next-intl";
import { useOffersKpi } from "@/data/kpi";
import { startOfDay, endOfDay } from "date-fns";
import { useSearchParams } from "next/navigation";

export default function SavingsInfoBanner() {
  const [visible, setVisible] = useState(false);
  const t = useTranslations("Home.savings-info-banner");
  const params = useSearchParams();
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const { data: user } = useCustomer();
  const { data: kpi } = useOffersKpi({
    dateFrom: startOfDay(new Date(2025, 5)).toISOString(),
    dateTo: endOfDay(new Date()).toISOString(),
  });

  useEffect(() => {
    setVisible(!!params.get("fromLogin"));
  }, [params]);

  return (
    <>
      {kpi?.offerKpiSetForPeriod?.savedAmount > 0 ? (
        <div
          className={cn("fixed w-full z-50", {
            hidden: !visible,
          })}
        >
          <div
            className={cn(
              "flex justify-center max-md:justify-start items-center h-full text-primary-black bg-secondary-grayBlue dark:bg-secondary-magenta5",
            )}
          >
            <Link
              href={"/profile/overview"}
              className="text-xl max-md:text-base my-4 pr-20 max-md:pr-6 pl-6"
            >
              {t.rich("message", {
                user: user?.firstName,
                amount: formatter
                  .format(kpi?.offerKpiSetForPeriod?.savedAmount)
                  .replace(",", "."),
                strong: (chunks) => (
                  <strong className="font-bold">{chunks}</strong>
                ),
              })}
            </Link>
          </div>
          <button
            className="absolute right-10 max-md:right-5 top-[50%] translate-y-[-50%] z-15"
            onClick={(e) => {
              e.preventDefault();
              setVisible(false);
            }}
          >
            <Icon
              className="h-4 w-4 max-md:h-4 max-md:w-4 dark:[&_circle]:fill-secondary-black dark:[&_path]:stroke-primary-white"
              icon="Close"
            />
            <span className="sr-only">Close</span>
          </button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
